import React from 'react';
import PublicPageLayout from './public-page-layout';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Input } from 'antd';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { forgotPassword, getLoginInProgress } from '../../features/auth.store';
import to from '../../utils/to';
import { toast } from 'react-toastify';
import eng from '../../utils/eng';

const ForgetPassword = () => {
  const isLoading = useSelector(getLoginInProgress);
  const dispatch = useDispatch();

  const handleForgetPassword = async ({ email }) => {
    const [err] = await to(dispatch(forgotPassword({ email })).unwrap());
    if (err) {
      return toast.error(eng.somethingWentWrong);
    }
    return toast.success(eng.toast.forgetPasswordRequested);
  };

  return (
    <PublicPageLayout>
      <div className="title fw-700">Hello! </div>
      <div className="sub-title fw-400">Did you forget your password?</div>
      <div className="sub-title fw-400">Enter your email address. We will send you a password reset link!</div>

      <Formik
        initialValues={{ email: '' }}
        onSubmit={handleForgetPassword}
        className="d-flex f-col"
        validateOnBlur
        validationSchema={Yup.object({
          email: Yup.string().email('Invalid email address').required('Required'),
        })}
      >
        <Form>
          <div className="login-field">
            <label htmlFor="email">Email ID</label>
            <Field name="email">
              {({ field, meta }) => (
                <Input
                  placeholder="Enter your email"
                  className={`${meta.touched && meta.error ? 'has-error' : ''}`}
                  suffix={meta.touched ? meta.error ? <CloseOutlined /> : <CheckOutlined /> : <span />}
                  {...field}
                />
              )}
            </Field>
          </div>
          <div className="remember-me-forgot-password d-flex jc-space-between">
            <Button disabled={isLoading} className="upper-case" type="primary" size="large" htmlType="submit">
              Submit
            </Button>
            <Link to="/login">Login</Link>
          </div>
        </Form>
      </Formik>
    </PublicPageLayout>
  );
};

export default ForgetPassword;
